function qaset() {
  let ads = getParameterByName('ads') //パラメータ名指定
  let settings

  switch (ads) {
    default:
      ;(basic = {
        introductionBanner: false, //導入バナー表示(true/false)
        scrollModal: -1, //スクロール率〇〇%でPOPUP表示(0~100、-1でOFF)
        mouseLeaveEvent: false, //マウスカーソルが画面外に離脱したときPOPUP表示(true/false)
        windowFocusEvent: true, //ウィンドウフォーカス時POPUP表示(true/false)
        delayModal: -1, //ページ滞在時間〇〇ミリ秒でPOPUP表示(-1でOFF)
      }),
        (settings = {
          default: {
            qaJson: 'qa.json',
            qaID: '1',
          },
        })
      break
  }
  return {
    settings: settings,
    basic: basic,
  }
}
